import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import StepZilla from 'react-stepzilla'
import { Col, Row } from 'react-bootstrap'
import { Card } from 'src/components'

import { getAllLocalities } from 'src/actions/address.actions'
import { createClient, onCreateClientStep } from 'src/actions/clients.actions'

import RequiredInformation from './RequiredInformation'
import SpecificClient from 'src/content/Clients/Create/SpecificClient'
import { geolocated } from 'react-geolocated'
import { validateGeoLocation } from 'src/utils/utilities'
import { selectCreate } from 'src/selectors/clients.selector'

import { useClientDynamicField } from 'src/content/Clients/hooks/useClientDynamicField'
import { Country } from 'src/enums/countries'
import { identificationTypesEnum } from 'src/enums/identificationTypes'
import { selectCompanyCountry } from 'src/selectors/company.selector'
import {
  mapFieldsToRequest,
  validateRequiredFields,
} from 'src/components/CompanyDynamicFields/DynamicFieldFunctions'
import { showAlert } from 'src/actions/alert.actions'
import { handlerError } from 'src/selectors/error.selector'
import { TaxpayerType } from '../../../enums/taxpayerTypeEnum'

const CreateClientIndex = props => {
  const country = useSelector(selectCompanyCountry)
  const client = useSelector(selectCreate)
  const { dynamicFields, setFields } = useClientDynamicField(true)

  const [error, setError] = useState({})

  const {
    inModal,
    onlyCloseModal,
    isGeolocationAvailable,
    isGeolocationEnabled,
    coords,
  } = props

  const dispatch = useDispatch()

  const onValidate = () => {
    let errors = {}
    if (!client.nit) errors.nit = 'Este campo es requerido'
    if (!client.companyName) errors.companyName = 'Este campo es requerido'
    if (!client.address) errors.address = 'Este campo es requerido'
    if (client.cui && client.cui.length < 13) errors.cui = 'El Cui debe tener 13 dígitos'

    if (country.id === Country.SV) {
      const clientDui = client.identifications?.[identificationTypesEnum.DUI]
      if (clientDui) {
        let dui = clientDui.value
        if (dui.length < 8 && dui !== '')
          errors.clientIdentifications = 'El DUI debe tener 8 dígitos'
      }
    }

    if (Object.keys(errors).length > 0) {
      setError(errors)
      return
    }

    const dynamicValidation = validateRequiredFields(dynamicFields)
    if (!dynamicValidation.ok) {
      dispatch(
        showAlert(
          handlerError(
            `Es necesario llenar los siguientes campos: ${dynamicValidation.fields}`,
          ),
        ),
      )
      return
    }

    let { identifications, viewers, selectedCategorization, ...clientData } = client
    const images = client.src ? [client.src] : []

    let identificationsValues = []
    if (identifications) identificationsValues = Object.values(identifications)

    const request = {
      ...clientData,
      businessType: 1,
      phoneCompany: 1,
      town: 1,
      contactType: 1,
      vendor: 0,
      deliverer: 0,
      callDay: 0,
      visitDay: 0,
      localityId: clientData.locality?.id,
      date: clientData.date ? clientData.date.valueOf() : undefined,
      identifications: identificationsValues,
      viewers: viewers?.map(viewer => viewer.value),
      exportationCountry: clientData?.exportationCountry?.value,
      fieldsRequest: mapFieldsToRequest(dynamicFields),
      taxpayerType:
        client.taxpayerTypeData !== null
          ? client.taxpayerTypeData?.value
          : TaxpayerType.OTHER,
    }

    if (client.exportationCountry && client.exportationCountry?.value !== null) {
      request.fiscalPrecinct = client.fiscalPrecinct?.code
      request.regime = client.regime?.code
    }

    dispatch(createClient(request, images, selectedCategorization))
  }

  const steps = [
    {
      name: 'Información necesaria',
      component: (
        <RequiredInformation
          jumpToStep
          inModal={inModal}
          onlyCloseModal={onlyCloseModal}
          onValidate={onValidate}
          error={error}
        />
      ),
    },
    {
      name: 'Información complementaria',
      component: (
        <SpecificClient
          props={props}
          onlyCloseModal={onlyCloseModal}
          setFields={setFields}
          dynamicFields={dynamicFields}
          onValidate={onValidate}
          error={error}
        />
      ),
    },
  ]

  const getLocation = async () => {
    const gpsResponse = await validateGeoLocation(
      { isGeolocationAvailable, isGeolocationEnabled, coords },
      null,
      null,
      null,
      true,
      true,
    )
    dispatch(
      onCreateClientStep({
        ...client,
        latitude: gpsResponse.cc.latitude,
        longitude: gpsResponse.cc.longitude,
      }),
    )
  }

  useEffect(() => {
    dispatch(getAllLocalities())
    dispatch(
      onCreateClientStep({
        images: [],
        auto: true,
        nit: 'CF',
        address: 'Ciudad',
        code: '',
        companyName: '',
        ...client,
      }),
    )
  }, [])

  useEffect(() => {
    if (!coords) return
    getLocation()
  }, [coords])

  return (
    <div>
      <Card>
        <Row>
          <Col>
            <div className={'step-progress'}>
              <StepZilla
                steps={steps}
                stepsNavigation={false}
                dontValidate={true}
                showNavigation={false}
              />
            </div>
          </Col>
        </Row>
      </Card>
    </div>
  )
}
export default geolocated({
  positionOptions: { enableHighAccuracy: true, userDecisionTimeout: 5000 },
})(CreateClientIndex)
